
/* PAYMENT */
export const GET_PAYMENT_LISTING = "GET_PAYMENT_LISTING";
export const GET_PAYMENT_LISTING_SUCCESS = "GET_PAYMENT_LISTING_SUCCESS";
export const GET_PAYMENT_LISTING_FAIL = "GET_PAYMENT_LISTING_FAIL";

export const GET_PAYMENT_DETAILS = "GET_PAYMENT_DETAILS";
export const GET_PAYMENT_DETAILS_SUCCESS = "GET_PAYMENT_DETAILS_SUCCESS";
export const GET_PAYMENT_DETAILS_FAIL = "GET_PAYMENT_DETAILS_FAIL";

export const UPDATE_PAYMENT = "UPDATE_PAYMENT";
export const UPDATE_PAYMENT_SUCCESS = "UPDATE_PAYMENT_SUCCESS";
export const UPDATE_PAYMENT_FAIL = "UPDATE_PAYMENT_FAIL";

export const ADD_PAYMENT = "ADD_PAYMENT";
export const ADD_PAYMENT_SUCCESS = "ADD_PAYMENT_SUCCESS";
export const ADD_PAYMENT_FAIL = "ADD_PAYMENT_FAIL";

export const DELETE_PAYMENT = "DELETE_PAYMENT";
export const DELETE_PAYMENT_SUCCESS = "DELETE_PAYMENT_SUCCESS";
export const DELETE_PAYMENT_FAIL = "DELETE_PAYMENT_FAIL";

export const UPDATE_PAYMENT_CONFIGURATION = "UPDATE_PAYMENT_CONFIGURATION";
export const UPDATE_PAYMENT_CONFIGURATION_SUCCESS = "UPDATE_PAYMENT_CONFIGURATION_SUCCESS";
export const UPDATE_PAYMENT_CONFIGURATION_FAIL = "UPDATE_PAYMENT_CONFIGURATION_FAIL";

export const RESET_PAYMENT_STATE = 'RESET_PAYMENT_STATE';